import { useGetDocumentTagNamesQuery } from 'features/documents/documents';
import { useParams } from 'react-router-dom';

const emptyArray = [];

/**
 * @param {number} [id]
 *
 * @returns {string[]}
 */
export function useGetDocumentTagNames(id) {
    const { documentId } = useParams();
    const idAsNumber = id ?? parseInt(documentId);

    const { documentTags } = useGetDocumentTagNamesQuery(idAsNumber, {
        selectFromResult: ({ data }) => ({
            documentTags: data ?? emptyArray,
        }),
        skip: !idAsNumber,
    });

    return documentTags;
}
